import React from "react";

const OurPartners = () => {
  return (
    <div className="p-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row gap-6">
        <div className="w-full lg:w-1/2 flex flex-col lg:mt-20">
          <img
            src="/assets/images/partner.png"
            alt="Partner 1"
            className="w-full  rounded-lg object-cover"
          />
          {/* <img
            src="/assets/images/part.jpg"
            alt="Partner 2"
            className="w-full h-48 sm:h-64 md:h-80 rounded-lg object-cover"
          /> */}
        </div>

        <div className="w-full lg:w-1/2 flex flex-col justify-center">
          <div className="text-center lg:text-left mb-10 mt-10">
            <p className="text-base sm:text-lg md:text-xl text-gray-600">
              As part of the{" "}
              <span className="font-semibold text-blue-600">
                Ayanshtech Solutions
              </span>{" "}
              family, we are closely connected to an extensive network of sister
              companies that share a common vision of{" "}
              <span className="font-semibold text-green-600">
                Innovation, Excellence, Customer Success
              </span>
              . Together, we operate across the IT industry, each contributing
              unique expertise to drive collective growth.
            </p>
          </div>

          <div className="shadow-lg rounded-xl p-6 hover:shadow-xl transition">
            <h3 className="text-xl sm:text-2xl font-semibold text-blue-700">
              WFMT Technology LLP
            </h3>
            <p className="text-gray-600 mt-2 text-sm sm:text-base">
              Specializing in IT Industry, WFMT Technology LLP is renowned for
              unique strengths.
            </p>
          </div>

          <div className="shadow-xl rounded-lg p-6 sm:p-8 mt-8">
            <h2 className="text-xl sm:text-2xl font-bold text-blue-700">
              Collaborative Synergies
            </h2>
            <p className="text-gray-600 mt-4 text-sm sm:text-base">
              Our connection with these companies enables us to leverage shared
              resources, expertise, and innovation, creating seamless solutions
              that exceed customer expectations. Together, we are stronger,
              delivering comprehensive value to our clients and stakeholders.
            </p>
          </div>

          <div className="shadow-xl rounded-lg p-6 sm:p-8 mt-8">
            <h2 className="text-xl sm:text-2xl font-bold text-green-700">
              A Shared Vision for the Future
            </h2>
            <p className="text-gray-600 mt-4 text-sm sm:text-base">
              As part of the{" "}
              <span className="font-semibold text-blue-600">
                Ayanshtech Solutions
              </span>{" "}
              ecosystem, we remain committed to advancing the IT Industry. By
              collaborating with our sister companies and benefiting from the
              support of our parent organization, we continue to innovate, grow,
              and make a lasting impact across the IT industry.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurPartners;
